import { render, staticRenderFns } from "./Z85-X18.vue?vue&type=template&id=1127bd34&scoped=true&"
import script from "./Z85-X18.vue?vue&type=script&lang=js&"
export * from "./Z85-X18.vue?vue&type=script&lang=js&"
import style0 from "./Z85-X18.vue?vue&type=style&index=0&id=1127bd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127bd34",
  null
  
)

export default component.exports